<template>
  <div class="match-invite-page">
    <Breadcrumb :type="1"></Breadcrumb>
    <div class="course-content">
      <img src="@/assets/images/icon-28.png" alt="" class="icon-image" />
      <div class="course-category">
        <div class="tip-category">课程分类:</div>
        <div
          class="category-flex"
          v-for="(item, index) in tabList"
          :key="index"
          :class="categoryId == item.categoryCode ? 'category-flex-active' : ''"
          @click="onTab(item)"
        >
          {{ item.categoryName }}
        </div>
      </div>
      <div class="course-list">
        <div
          class="list-flex"
          v-for="(item, index) in newsList"
          :key="index"
          @click="openLink(item)"
        >
          <div class="flex-image">
            <img :src="item.cover" alt="" class="image" />
          </div>
          <div class="flex-title">{{ item.articleName }}</div>
        </div>
      </div>
      <Pagination
        :pageSize="pageSize"
        :pageCount="pageCount"
        @changePageClick="changePageClick"
        v-if="newsList.length > 0"
      ></Pagination>
      <el-empty description="暂无数据" v-if="newsList.length == 0"></el-empty>
    </div>
  </div>
</template>

<script>
import { getNavItemByCode } from '@/api/common/common.js'
import { getArticlePage } from '@/api/home/home.js'
import Breadcrumb from '@/components/common/breadcrumb'
import Pagination from '@/components/common/Pagination.vue'
export default {
  components: {
    Breadcrumb,
    Pagination
  },
  data() {
    return {
      categoryId: '',
      tabcode: '',
      tabList: [],
      tabIndex: '', // 选中的
      pageSize: 6, //分页数量
      pageCount: 0, //列表总数
      newsList: []
    }
  },
  created() {
    this.categoryId = this.$route.query?.categoryId
    this.tabcode = this.$route.query?.tabcode
    this.fetchData()
  },
  methods: {
    // 获取项目分类
    fetchData() {
      getNavItemByCode(this.categoryId).then((res) => {
        this.tabList = res.data[0]?.list
        if (this.tabList.length != 0) {
          this.categoryId = this.tabList[0].categoryCode
          this.getArticlePage()
        }
      })
    },
    //获取文章列表
    getArticlePage(page = 1) {
      getArticlePage({
        page: page,
        limit: this.pageSize,
        categoryCode: this.categoryId
      }).then((res) => {
        if (!res.data) return
        this.newsList = res.data.list
        this.pageCount = Number(res.data.count)
      })
    },
    //切换页面
    changePageClick(page) {
      this.getArticlePage(page)
    },
    onTab(row) {
      this.categoryId = row.categoryCode
      this.getArticlePage()
    },
    //   跳转
    openLink(item) {
      if (item.articleUrl) {
        window.open(item.articleUrl)
      } else {
        this.$router.push({
          path: '/base/project/detail',
          query: {
            id: item.articleId,
            tabcode: this.tabcode,
            categoryId: this.$route.query?.categoryId
          }
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.match-invite-page {
  display: flex;
  flex-direction: column;
  .course-content {
    display: flex;
    flex-direction: column;
    width: 1472px;
    margin: 34px auto 120px;
    .course-list {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      margin-top: 48px;
      gap: 33px;
      .list-flex {
        display: flex;
        flex-direction: column;
        border-radius: 10px;
        border: 0 solid #e5e7eb;
        background: #fff;
        box-shadow: -3px -7px 9.1px -4px rgba(0, 0, 0, 0.02),
          0 10px 15px -3px rgba(0, 0, 0, 0.06);
        width: 343px;
        height: 374px;
        padding-bottom: 16px;
        box-sizing: border-box;
        cursor: pointer;
        position: relative;
        top: 0;
        transition: all 0.3s ease-in-out;
        .flex-title {
          height: 58px;
          line-height: 29px;
          color: #1f2937;
          font-size: 18px;
          font-weight: 600;
          width: 311px;
          margin: 10px auto 0;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .flex-image {
          width: 343px;
          height: 290px;
          border-radius: 10px 10px 0 0;
          overflow: hidden;
          .image {
            width: 343px;
            height: 290px;
            object-fit: cover;
          }
        }
      }
      .list-flex:hover {
        top: -10px;
      }
    }
    .course-category {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      border: 1px solid #e6e6e6;
      background: #f9fafb;
      box-sizing: border-box;
      padding: 34px 38px;
      gap: 32px;
      .category-flex {
        width: 128px;
        color: #333;
        font-size: 18px;
        height: 30px;
        line-height: 30px;
        cursor: pointer;
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        padding: 0 10px;
      }
      .category-flex-active {
        border-radius: 2px;
        background: #1b56a9;
        color: #fff;
      }
      .tip-category {
        width: 100px;
        color: #111;
        font-size: 20px;
        font-weight: bold;
        height: 30px;
        line-height: 30px;
      }
    }
    .icon-image {
      width: 250px;
      height: 64px;
      margin: 0 auto 34px;
      object-fit: cover;
    }
  }
}

// 手机端css
.mobile-content {
  .match-invite-page {
    .course-content {
      width: 345px;
      margin: 20px auto 60px;
      .course-list {
        margin-top: 30px;
        gap: 15px;
        .list-flex {
          width: calc(100% / 2 - 7.5px);
          height: auto;
          padding-bottom: 8px;
          .flex-title {
            height: 40px;
            line-height: 20px;
            width: calc(100% - 10px);
            font-size: 14px;
            margin-top: 8px;
          }
          .flex-image {
            width: 100%;
            height: 200px;
            .image {
              width: 100%;
              height: 200px;
            }
          }
        }
      }
      .course-category {
        padding: 17px 18px;
        gap: 10px 2px;
        .category-flex {
          width: 75px;
          padding: 0 6px;
          font-size: 13px;
          height: 25px;
          line-height: 25px;
        }
        .tip-category {
          width: 70px;
          height: 25px;
          line-height: 25px;
          font-size: 14px;
        }
      }
      .icon-image {
        width: 150px;
        height: 38.4px;
      }
    }
  }
}
</style>
